/* "When the user clicks on the main details toggle, the main details toggle is set to open."

The first line of the function is the function declaration. The function declaration is the first
line of the function. It tells the browser that the following lines of code are a function */
class DetailsDisclosure extends HTMLElement {
  /**
   * The constructor function is called when the component is created. It sets up the event listeners
   * for the component
   */
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener("mouseover", this.open.bind(this));
		this.mainDetailsToggle.addEventListener("mouseout", this.close.bind(this));
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  /**
   * If the user clicks outside of the dropdown, the dropdown will close
   */
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  /**
   * If the main details toggle is open, play all the animations, otherwise cancel them
   */
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  /**
   * It removes the open attribute from the main details element, and sets the aria-expanded attribute
   * on the summary element to false
   */
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
  
  /**
   * "When the user clicks on the main details toggle, the main details toggle is set to open."
   * 
   * The first line of the function is the function declaration. The function declaration is the first
   * line of the function. It tells the browser that the following lines of code are a function
   */
  open() {
		this.mainDetailsToggle.setAttribute("open", "");
	}
}

customElements.define('details-disclosure', DetailsDisclosure);

/* The `HeaderMenu` class extends the `DetailsDisclosure` class and adds a `header` property that is
used to prevent the header from hiding when the main details toggle is open */
class HeaderMenu extends DetailsDisclosure {
  /**
   * The constructor function is a special function that is called when an object is created from a
   * class
   */
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  /**
   * If the main details toggle is open, prevent the header from hiding
   * @returns The bottom position of the header element.
   */
  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
